import React from 'react';
import ContactDetail from '../components/contact/ContactDetail';

const ContactDetailPage = () => {
    return (
        <ContactDetail />
    );
}

export default ContactDetailPage;
